/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StrapiBlockFromJSON, StrapiBlockToJSON, } from './StrapiBlock';
import { AnswerComponentFromJSON, AnswerComponentToJSON, } from './AnswerComponent';
/**
 * Check if a given object implements the QuestionComponent interface.
 */
export function instanceOfQuestionComponent(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('useFooter' in value) || value['useFooter'] === undefined)
        return false;
    if (!('isUserInput' in value) || value['isUserInput'] === undefined)
        return false;
    if (!('isRequired' in value) || value['isRequired'] === undefined)
        return false;
    return true;
}
export function QuestionComponentFromJSON(json) {
    return QuestionComponentFromJSONTyped(json, false);
}
export function QuestionComponentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'],
        'header': json['header'] == null ? undefined : (json['header'].map(StrapiBlockFromJSON)),
        'footer': json['footer'] == null ? undefined : (json['footer'].map(StrapiBlockFromJSON)),
        'useFooter': json['useFooter'],
        'isUserInput': json['isUserInput'],
        'isRequired': json['isRequired'],
        'isMultipleChoice': json['isMultipleChoice'] == null ? undefined : json['isMultipleChoice'],
        'isSingleLine': json['isSingleLine'] == null ? undefined : json['isSingleLine'],
        'answers': json['answers'] == null ? undefined : (json['answers'].map(AnswerComponentFromJSON)),
    };
}
export function QuestionComponentToJSON(json) {
    return QuestionComponentToJSONTyped(json, false);
}
export function QuestionComponentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'header': value['header'] == null ? undefined : (value['header'].map(StrapiBlockToJSON)),
        'footer': value['footer'] == null ? undefined : (value['footer'].map(StrapiBlockToJSON)),
        'useFooter': value['useFooter'],
        'isUserInput': value['isUserInput'],
        'isRequired': value['isRequired'],
        'isMultipleChoice': value['isMultipleChoice'],
        'isSingleLine': value['isSingleLine'],
        'answers': value['answers'] == null ? undefined : (value['answers'].map(AnswerComponentToJSON)),
    };
}
